import React from 'react';
import ButtonTooltipBadge from '../ButtonTooltipBadge/ButtonTooltipBadge';
import { ButtonFilterProps } from './ButtonFilter.type';

const ButtonFilter: React.FC<ButtonFilterProps> = ({ badge, onClick }) => {
  return (
    <ButtonTooltipBadge
      badge={badge}
      dataTestId="button-filter"
      onClick={onClick}
      title={'Advance Filter'}
      content={
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="10"
          viewBox="0 0 14 10"
          fill="none"
        >
          <path
            d="M5.5 9.5V8H8.5V9.5H5.5ZM2.5 5.75V4.25H11.5V5.75H2.5ZM0.25 2V0.5H13.75V2H0.25Z"
            fill="#E4E4E4"
          />
        </svg>
      }
    />
  );
};

export default ButtonFilter;
